import _ from '../../common/utility';

function setCoeRightRailStickyPos() {
    if (!(_.isCOE() && $('.coe-v2').length)) return;
    function setRightRailAdsStickyPosition() {
        if ($('.page-body .sticky-ad').length > 0 && window.breakpoint != 1) {
            let mainOffset = $('main').offset();
            let carouselHeaderOffset = $('main header .coe_carousel .header-coe').offset(); // Right rail Ceiling pos
            let icymiOffset = $('section.hp_poctools').offset();  // Right rail Floor pos
            let stickyRightAdsCeiling = carouselHeaderOffset.top - mainOffset.top;
            let stickyRightAdsHeight = icymiOffset.top - mainOffset.top - stickyRightAdsCeiling - 20;
            $('.page-body .sticky-ad').css({
                top: stickyRightAdsCeiling + 20,
                height: Math.floor(stickyRightAdsHeight)
            })
        }
    }

    window.addEventListener("scroll", setRightRailAdsStickyPosition);
    window.addEventListener("resize", setRightRailAdsStickyPosition);
    $(document).ready(function () {
        setRightRailAdsStickyPosition();
    })

}

export default _.catch(setCoeRightRailStickyPos);